export default "__VITE_ASSET__DluWC_fV__"